module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-sad.1d88c685.png";